import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MessageData, TypeToast } from '../../models/messagedata';

@Component({
  selector: 'smrts-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: false
})
export class MessageComponent {
  success = false;
  warning = false;
  error = false;

  constructor(private snackBarRef: MatSnackBarRef<MessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: MessageData) {
    this.success = data.typeToast === TypeToast.SUCCESS;
    this.warning = data.typeToast === TypeToast.WARNING;
    this.error = data.typeToast === TypeToast.ERROR;
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
